import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveDynamicComponent as _resolveDynamicComponent, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative min-h-[100dvh] w-full bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800" }
const _hoisted_2 = { class: "w-full min-h-[100dvh] flex flex-col md:flex-row bg-white dark:bg-gray-800 overflow-hidden" }
const _hoisted_3 = { class: "hidden md:flex w-1/2 bg-gradient-to-tr from-primary to-secondary dark:from-primary-light/10 dark:to-secondary-light/10 items-center justify-center p-8" }
const _hoisted_4 = { class: "text-center text-white space-y-6" }
const _hoisted_5 = { class: "text-3xl font-bold" }
const _hoisted_6 = { class: "h-8 flex items-center justify-center overflow-hidden" }
const _hoisted_7 = { class: "flex flex-col justify-center items-center w-full md:w-1/2 p-4 sm:p-8 lg:p-12 relative flex-1 md:flex-none overflow-hidden" }
const _hoisted_8 = { class: "flex md:hidden flex-col items-center justify-center pt-4 pb-8 px-4 shrink-0" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "w-full max-w-md space-y-4 md:space-y-8 relative" }
const _hoisted_11 = {
  key: 0,
  class: "absolute inset-0 z-10 flex items-center justify-center bg-white/70 dark:bg-gray-800/70 rounded-2xl"
}
const _hoisted_12 = { class: "bg-white dark:bg-gray-800 p-6 md:p-8 rounded-2xl shadow-2xl border border-gray-100 dark:border-gray-700" }
const _hoisted_13 = { class: "relative" }
const _hoisted_14 = ["type"]
const _hoisted_15 = { class: "flex items-center justify-between text-sm" }
const _hoisted_16 = { class: "flex items-center text-slate-600 dark:text-slate-400" }
const _hoisted_17 = ["disabled"]

import { ref, computed, onMounted } from 'vue'
import { useThemeStore } from '@/stores/theme'
// import { useAuthStore } from '@/stores/auth'
import { useLogin } from '@/composables/auth/useLogin'
// import { useRouter } from 'vue-router'
// import { getLastAccessibleRoute } from '@/router'
import SunIcon from '@/components/icons/SunIcon.vue'
import MoonIcon from '@/components/icons/MoonIcon.vue'
import { Eye, EyeOff } from 'lucide-vue-next'
import { useToast } from 'vue-toastification'

const toastTimeout = 5000


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const appTitle = computed(() => process.env.VUE_APP_TITLE || 'PLANET Home Healthcare')

const taglines = [
	'Compassionate Care',
	'Your Independence',
	'Quality Home Health',
	'Caring Professionals',
]
const currentTagline = ref(0)


const themeStore = useThemeStore()
const isDarkMode = computed(() => themeStore.isDarkMode)
// const authStore = useAuthStore()
// const router = useRouter()

const email = ref('')
const password = ref('')
const rememberMe = ref(false)
const showPassword = ref(false)

const toast = useToast()
const { loading, error, handleLogin: login } = useLogin({ email, password, rememberMe })

const handleLogin = async () => {
	await login()

	// console.log(error.value)

	if (error.value) {
		toast.error(error.value, { timeout: toastTimeout })
	}
}

onMounted(() => {
	setInterval(() => {
		currentTagline.value = (currentTagline.value + 1) % taglines.length
	}, 3500)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(themeStore).toggleTheme())),
      class: "md:hidden absolute top-4 right-4 p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition z-10",
      "aria-label": "Toggle dark mode"
    }, [
      (isDarkMode.value)
        ? (_openBlock(), _createBlock(SunIcon, { key: 0 }))
        : (_openBlock(), _createBlock(MoonIcon, { key: 1 }))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("img", {
            src: "images/main-logo-dark.png",
            alt: "App Logo",
            class: "mx-auto h-24 w-[18rem] object-contain drop-shadow-md"
          }, null, -1)),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(appTitle.value), 1),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_Transition, {
              name: "rotate",
              mode: "out-in"
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("span", {
                  class: "block text-lg font-medium",
                  key: currentTagline.value
                }, _toDisplayString(taglines[currentTagline.value]), 1))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: isDarkMode.value ? 'images/main-logo-dark.png' : 'images/main-logo.png',
            alt: "App Logo",
            class: "h-16 w-auto max-w-[18rem] object-contain drop-shadow-sm"
          }, null, 8, _hoisted_9)
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(themeStore).toggleTheme())),
          class: "hidden md:block absolute top-6 right-6 p-2 rounded-full text-slate-500 dark:text-slate-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition",
          "aria-label": "Toggle dark mode"
        }, [
          (isDarkMode.value)
            ? (_openBlock(), _createBlock(SunIcon, { key: 0 }))
            : (_openBlock(), _createBlock(MoonIcon, { key: 1 }))
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_unref(loading))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[7] || (_cache[7] = [
                _createElementVNode("svg", {
                  class: "animate-spin h-10 w-10 text-primary",
                  xmlns: "http://www.w3.org/2000/svg",
                  fill: "none",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("circle", {
                    class: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    "stroke-width": "4"
                  }),
                  _createElementVNode("path", {
                    class: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  })
                ], -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("form", {
              class: "space-y-4 md:space-y-6",
              onSubmit: _withModifiers(handleLogin, ["prevent"])
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "block text-lg font-bold text-slate-800 dark:text-slate-200 mb-6 justify-center text-center" }, "Sign in to your account", -1)),
              _createElementVNode("div", null, [
                _cache[8] || (_cache[8] = _createElementVNode("label", {
                  for: "email",
                  class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1"
                }, " Email address or Username ", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "text",
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((email).value = $event)),
                  class: "w-full px-3 py-2 md:px-4 md:py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-slate-900 dark:text-white focus:ring-2 focus:ring-orange-300 outline-none",
                  placeholder: "you@example.com"
                }, null, 512), [
                  [_vModelText, email.value]
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  for: "password",
                  class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1"
                }, " Password ", -1)),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    id: "password",
                    type: showPassword.value ? 'text' : 'password',
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
                    class: "w-full px-3 py-2 md:px-4 md:py-3 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 text-slate-900 dark:text-white focus:ring-2 focus:ring-orange-300 outline-none pr-10",
                    placeholder: "********"
                  }, null, 8, _hoisted_14), [
                    [_vModelDynamic, password.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (showPassword.value = !showPassword.value)),
                    class: "absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
                  }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(showPassword.value ? _unref(EyeOff) : _unref(Eye)), { class: "h-5 w-5" }))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    id: "remember-me",
                    name: "remember-me",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((rememberMe).value = $event)),
                    class: "rounded border-gray-300 text-orange-400 focus:ring-orange-300 mr-2"
                  }, null, 512), [
                    [_vModelCheckbox, rememberMe.value]
                  ]),
                  _cache[10] || (_cache[10] = _createTextVNode(" Remember me ", -1))
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("a", {
                  href: "/portal/forgot-password",
                  class: "text-primary hover:text-primary-hover dark:text-secondary-dark-text dark:hover:text-secondary-dark-hover font-medium hover:underline"
                }, "Forgot your password?", -1))
              ]),
              _createElementVNode("button", {
                type: "submit",
                disabled: _unref(loading) || !email.value || !password.value,
                class: "w-full py-2 md:py-3 px-4 bg-primary hover:bg-primary-hover dark:bg-primary-dark dark:hover:bg-primary-dark-hover text-white font-bold rounded-lg shadow-lg transform transition-all active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed disabled:active:scale-100"
              }, _toDisplayString(_unref(loading) ? 'Signing in...' : 'Sign in'), 9, _hoisted_17)
            ], 32),
            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-center text-sm text-slate-600 dark:text-slate-400 mt-6" }, [
              _createTextVNode(" Don't have an account? "),
              _createElementVNode("a", {
                href: "/portal/register",
                class: "text-primary hover:text-primary-hover dark:text-secondary-dark-text dark:hover:text-secondary-dark-hover font-bold hover:underline"
              }, " Register ")
            ], -1))
          ])
        ])
      ])
    ])
  ]))
}
}

})